import PropTypes from 'prop-types';
import parse from 'html-react-parser';
import { connect } from 'react-redux';
import { useEffect, useState, useContext } from 'react';

import Container from 'react-bootstrap/Container';
import Col from 'react-bootstrap/Col';
import ScreenerAppContext from '../../../../stores/screener/screener-app-context';
import expenseDisclosures from '../../../../statics/screener/expense-disclosures';
import footnoteDisclaimers from '../../../../statics/screener/footnote-disclaimers';
import format from '../../../../utils/format';
import { FIELDS } from '../../../../shared/screener-constants';
import { FUND_TYPES } from '../../../../stores/profile/get-fund-type';
import { className } from '../../../../utils/GlobalCssProxy';
import { fetchDisclosuresBulk } from '../../../../stores/screener/screener-redux-store';
import {
  getExpenseDisclosure,
  getFrequentTraderDisclosuresFund
} from '../../../../utils/disclaimers-helpers';
import { internalApiClient } from '../../../../services/screener-service';
import { isModel } from '../../../../utils/sharedHelpers';

export const PrintDisclosures = ({ resultData, getDisclosuresBulk }) => {
  const [screenerData, setScreenerData] = useState(resultData?.screenerData);
  const [screenerDisclosuresBulkNotes, setScreenerDisclosuresBulkNotes] = useState([]); // todo: use resultData?.screenerDisclosuresNotes
  const { channel, yyy } = useContext(ScreenerAppContext);
  const [hasRetirePlusPro, setHasRetirePlusPro] = useState(false);
  const [hasRetirePlus, setHasRetirePlus] = useState(false);
  const [overallDisclosures, setOverallDisclosures] = useState([]);
  const [specificAdditionalDisclosures, setSpecificAdditionalDisclosures] = useState([]);

  const xidArray = [];

  const transformText = text => {
    text = text.replace(/<p>(.*?)<\/p>/g, '<div>$1</div>');
    text = text.replace(/<br>/g, ' ');
    text = text.replace(/<br><br>/g, '</div><div>');
    text = text.replace(/<br>$/g, '</div>');
    return text;
  };

  const callFetchDisclosuresBulk = async xids => {
    const service = await internalApiClient(yyy, channel);
    getDisclosuresBulk(xids, service);
  };

  const getOverallDisclosures = async () => {
    let xidList = '';
    const overallDisclosureList = [];

    screenerData?.forEach((item, index) => {
      xidList = xidList.concat(`${item.TCWSODIssue}|`);
      if (item.TCFundType === FUND_TYPES.variableAnnuityCref) {
        const hasCrefDisclosures = overallDisclosureList.some(
          disclosure => disclosure.header === 'CREF Expenses'
        );
        if (hasCrefDisclosures) return;
        overallDisclosureList.push({
          header: 'CREF Expenses',
          subText: 'The following expense information applies to all CREF Variable Annuities',
          content: transformText(expenseDisclosures.crefVAExpenseNote)
        });
      }
    });

    if (hasRetirePlusPro) {
      overallDisclosureList.push({
        header: 'RetirePlus Model Portfolio – Additional Information',
        subText: 'The following disclosures applies to all RetirePlus Pro Models on this plan:',
        content: `${expenseDisclosures.expenseRatioRetirePlusProNotBold}${footnoteDisclaimers.retirePlusAssetAllocations}${footnoteDisclaimers.retirePlusPlanSponsorDisclosure}`
      });
    }

    if (hasRetirePlus) {
      overallDisclosureList.push({
        header: `${hasRetirePlusPro ? '' : 'RetirePlus Model Portfolio – Additional Information'}`,
        subText: 'The following disclosures applies to all RetirePlus Select Models on this plan:',
        content: `${footnoteDisclaimers.retirePlusAssetAllocations}${footnoteDisclaimers.retirePlusPerformance}`
      });
    }

    setOverallDisclosures(overallDisclosureList);
  };

  const mapFundSpecificListDisclosures = (disclosureResult, item) => {
    if (!disclosureResult || !item) {
      return;
    }

    const fundSpecificListDisclosuresList = [];
    const nonPropMFCapNote = item[FIELDS.TCEXPENSEWAIVERCAPNOTE];
    const expenseDisclosure = getExpenseDisclosure(item, nonPropMFCapNote);
    const frequentTraderDisclosuresFund = getFrequentTraderDisclosuresFund(item);

    if (disclosureResult?.numberedNote && item.TCFundType !== FUND_TYPES.variableAnnuityCref) {
      fundSpecificListDisclosuresList.push(transformText(disclosureResult.numberedNote));
    }
    if (disclosureResult?.expenseWaiverCapNote) {
      fundSpecificListDisclosuresList.push(transformText(disclosureResult.expenseWaiverCapNote));
    }
    if (
      item.TCFundType !== FUND_TYPES.variableAnnuityCref &&
      item.TCFundType !== FUND_TYPES.variableAnnuityTiaa &&
      expenseDisclosure &&
      format.text(expenseDisclosure) !== '--'
    ) {
      fundSpecificListDisclosuresList.push(transformText(expenseDisclosure));
    }
    if (frequentTraderDisclosuresFund && format.text(frequentTraderDisclosuresFund) !== '--') {
      fundSpecificListDisclosuresList.push(transformText(frequentTraderDisclosuresFund));
    }

    if (disclosureResult?.modelNameChangedDisclosureList) {
      disclosureResult.modelNameChangedDisclosureList.forEach(note =>
        fundSpecificListDisclosuresList.push(transformText(note))
      );
    }
    const joinedDisclosures = fundSpecificListDisclosuresList.join('');
    return joinedDisclosures;
  };

  const getSpecificAdditionalDisclosures = async () => {
    const fundSpecificList = [];
    if (!screenerData || !screenerDisclosuresBulkNotes) {
      return;
    }
    let idIndex = 0;
    screenerData.forEach((item, index) => {
      if (isModel(item.TCFundType)) {
        return;
      }

      const disclosureItem = screenerDisclosuresBulkNotes.find(
        discItem => discItem.xid === item.TCWSODIssue
      );
      const mappedDisclosure = mapFundSpecificListDisclosures(disclosureItem, item);

      if (mappedDisclosure) {
        fundSpecificList.push({
          id: idIndex,
          xid: item.TCWSODIssue,
          displayName: `${item.TCInvestmentName} [${item.TCDerivedTicker}]`,
          disclosures: mappedDisclosure
        });
        idIndex++;
      }
    });
    setSpecificAdditionalDisclosures(fundSpecificList);
  };

  const hardCodedFooterDisclosures = `<p><b>Investment, insurance and annuity products are not FDIC insured, are not bank guaranteed, are not deposits, are not insured by any federal government agency, are not a condition to any banking service or activity, and may lose value.</b> </br></br>
TIAA-CREF Individual & Institutional Services, LLC, Member FINRA and SIPC, distributes securities products. SIPC only protects customers' securities and cash held in brokerage accounts. Annuity contracts and certificates are issued by Teachers Insurance and Annuity Association of America (TIAA) and College Retirement Equities Fund (CREF), New York, NY. Each is solely responsible for its own financial condition and contractual obligations.</br></br>
© 2024 and prior years, Teachers Insurance and Annuity Association of America-College Retirement Equities Fund, New York, NY 10017 </p>`;

  useEffect(() => {
    if (!resultData?.screenerData?.length) {
      setScreenerDisclosuresBulkNotes([]);
      setOverallDisclosures([]);
      setSpecificAdditionalDisclosures([]);
      return;
    }

    const difference = resultData?.screenerData
      .filter(x => !screenerData.includes(x))
      .concat(screenerData.filter(x => !resultData?.screenerData.includes(x)));

    if (difference?.length && resultData?.screenerData.length > 1) {
      resultData?.screenerData?.forEach((item, index) => {
        xidArray.push(item.TCWSODIssue);
      });

      setScreenerData(resultData?.screenerData);
      const isHasRetirePlusPro = resultData?.screenerData.some(
        item => item?.TCFundType === (FUND_TYPES.customPortfolioModel || FUND_TYPES.retirePlusPro)
      );
      setHasRetirePlusPro(isHasRetirePlusPro);
      const isHasRetirePlus = resultData?.screenerData.some(
        item => item?.TCFundType === FUND_TYPES.retirePlus
      );
      setHasRetirePlus(isHasRetirePlus);
      callFetchDisclosuresBulk(xidArray); // Get xid List first, and call getProfileFootnotesBulk API.
    }
  }, [resultData?.screenerData]);

  useEffect(() => {
    if (resultData?.disclosureBulkNotes.length) {
      setScreenerDisclosuresBulkNotes(resultData?.disclosureBulkNotes);
    } else {
      setScreenerDisclosuresBulkNotes([]);
      setOverallDisclosures([]);
      setSpecificAdditionalDisclosures([]);
    }
  }, [resultData?.disclosureBulkNotes]);

  useEffect(() => {
    if (screenerDisclosuresBulkNotes.length) {
      getOverallDisclosures();
      getSpecificAdditionalDisclosures();
    }
  }, [screenerDisclosuresBulkNotes]);

  return (
    <Container fluid={'xl'} {...className('print-only')}>
      <Col sm={12}>
        {overallDisclosures?.length > 0 &&
          overallDisclosures.map((disclosureSection, index) => (
            <div
              data-key={`${disclosureSection.header || ''}-${index}`.header}
              key={`${disclosureSection.header || ''}-${index}`.header}
            >
              <header {...className('print-screener-disclosure-subtitle')}>
                {disclosureSection.header}
              </header>
              {disclosureSection.subText && <br></br>}
              <div>{disclosureSection.subText}</div>
              {disclosureSection.content && <br></br>}
              <div>{parse(disclosureSection.content)}</div>
            </div>
          ))}

        {specificAdditionalDisclosures.length > 0 && (
          <header {...className('print-screener-disclosure-subtitle')}>
            {'Investment Specific Additional Information'}
          </header>
        )}
        {specificAdditionalDisclosures.length > 0 &&
          specificAdditionalDisclosures.map((item, index) => (
            <div data-key={`${item.id || ''}-${index}`} key={`${item.id || ''}-${index}`}>
              <div {...className('print-screener-disclosure-fund-title')}>{item.displayName}:</div>
              <div>{parse(item.disclosures)}</div>
            </div>
          ))}
        {screenerDisclosuresBulkNotes.length > 0 && (
          <div {...className('print-screener-disclosure-margin')}>
            <div>{parse(hardCodedFooterDisclosures)}</div>
          </div>
        )}
      </Col>
    </Container>
  );
};

PrintDisclosures.propTypes = {
  resultData: PropTypes.object,
  getDisclosuresBulk: PropTypes.func
};

const mapStateToProps = state => {
  return {
    resultData: state.resultData
  };
};

const mapDispatchToProps = dispatch => {
  return {
    getDisclosuresBulk: (xidArray, service) => dispatch(fetchDisclosuresBulk(xidArray, service))
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(PrintDisclosures);
